import { render, staticRenderFns } from "./CmsText.vue?vue&type=template&id=a7bb3fca&"
import script from "./CmsText.vue?vue&type=script&lang=js&"
export * from "./CmsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports